import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import CustomButton from "@/shared/components/kit/button";
import { CircularProgress } from "@mui/material";
import ProviderTabs from "@/modules/user/components/credits/validation/payment/validationAfterPayment/components/providerTabs";
import { useMutation } from "@tanstack/react-query";
import {getProviders, setProviders} from "@/api/user/home";
import { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import {getProvidersDataType, setProvidersPayloadType, setProvidersPromiseType} from "@/types/api/user/home.type.data";
import CardBoxLayout from "@/modules/merchant/layout/cardBoxLayout";

interface ProviderStepProps {
    onSuccess: () => void;
}

const ProviderStep = ({ onSuccess }: ProviderStepProps) => {
    const [errorMessage, setErrorMessage] = useState<string>();
    const [providersData, setProvidersData] = useState<getProvidersDataType[]>([]);
    const providerStepRef = useRef<{ handleSubmit: () => void } | null>(null);

    const { mutate: getProvidersData, isPending: getProvidersLoading } = useMutation({
        mutationFn: getProviders,
        onSuccess: (data) => {
            setProvidersData(data.data);
        },
        onError: (error: AxiosError<{ message: string }>) => {
            toast.error(error?.response?.data?.message || "خطا در دریافت اطلاعات");
            setErrorMessage(error?.response?.data?.message || "خطا در دریافت اطلاعات");
        }
    });

    const {mutate:postSetProviders , isPending} = useMutation({
        mutationFn:setProviders,
        onSuccess:(respond:setProvidersPromiseType)=>{
            if(respond.data.status){
                toast.success(respond.message);
                onSuccess();
            }
            if(!respond.data.status){
                toast.error(respond.message);
            }
        },
        onError:(error: AxiosError<{ message: string }>) => {
            toast.error(error?.response?.data?.message || "خطا در ثبت اطلاعات");
        }
    });

    const handleSubmit = (data:setProvidersPayloadType) => {
        postSetProviders(data);
    }

    const handleNextStep = () => {
        if (providerStepRef.current) {
            providerStepRef.current.handleSubmit();
        }
    };

    useEffect(() => {
        getProvidersData();
    }, [getProvidersData]);

    return (
        <StackKit>
            {getProvidersLoading ?
                <StackKit direction="column" sx={{ width: "100%", alignItems: "center", height: "400px", justifyContent: "center" }}>
                    <CircularProgress sx={{ color: "#136A74" }} size={22} />
                </StackKit>
                :
                <StackKit direction="column" sx={{ width: "100%", alignItems: "flex-start", height: "400px", justifyContent: "space-between" }}>
                    <ProviderTabs ref={providerStepRef} onSubmit={handleSubmit} data={providersData} />
                    <StackKit direction="row" justifyContent="end" width="100%">
                        <CustomButton variant="contained" sx={{ mt: 3, width: "fit-content" }} onClick={handleNextStep}>
                            <TypoGraphyKit variant="body1" sx={{ display: "flex", justifyContent: "center", alignItems: "center", minWidth: "50px" }}>
                                {isPending ? (
                                    <CircularProgress sx={{ color: "#136A74" }} size={22} />
                                ) : "مرحله بعد"}
                            </TypoGraphyKit>
                        </CustomButton>
                    </StackKit>
                </StackKit>
            }
        </StackKit>
    );
};

export default ProviderStep;